export default __webpack_public_path__ + "static/media/T735_CoC.cf734c3e.pdf";